var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWww = function SvgWww(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 11H29.1M3.9 20H29.1M3 15.5C3 17.2728 3.34919 19.0283 4.02763 20.6662C4.70606 22.3041 5.70047 23.7923 6.95406 25.0459C8.20765 26.2995 9.69588 27.2939 11.3338 27.9724C12.9717 28.6508 14.7272 29 16.5 29C18.2728 29 20.0283 28.6508 21.6662 27.9724C23.3041 27.2939 24.7923 26.2995 26.0459 25.0459C27.2995 23.7923 28.2939 22.3041 28.9724 20.6662C29.6508 19.0283 30 17.2728 30 15.5C30 11.9196 28.5777 8.4858 26.0459 5.95406C23.5142 3.42232 20.0804 2 16.5 2C12.9196 2 9.4858 3.42232 6.95406 5.95406C4.42232 8.4858 3 11.9196 3 15.5Z",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7534 2C13.2264 6.04942 11.8867 10.7268 11.8867 15.5C11.8867 20.2732 13.2264 24.9506 15.7534 29M17.2534 2C19.7804 6.04942 21.1201 10.7268 21.1201 15.5C21.1201 20.2732 19.7804 24.9506 17.2534 29",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWww;